import { makeStyles } from '@mui/styles';
const modalStyles = makeStyles(() => ({
    container: {
        boxShadow: '2px 2px 10px 2px rgba(0,0,0,0.7)',
    },
}), { name: 'Common_Modal' });
export default modalStyles;
//# sourceMappingURL=modal.styles.js.map